<template>
	<div class="create-warehouse">
		<div class="box">
			<div>اطلاعات کاربر</div>
			<div class="d-flex flex-row align-items-center mt-3">
				<div class="row mt-3 w-100">
					<div class="col-lg-6 col-sm-12">
						<Materialnput label="نام انگلیسی کالا" v-model="enName" inputType="text" />
					</div>
					<div class="col-lg-6 col-sm-12">
						<Materialnput label="نام فارسی کالا" v-model="faName" />
					</div>
					<div class="col-lg-6 col-sm-12">
						<Materialnput label="کد کالا" v-model="productCode" />
					</div>
					<div class="col-lg-6 col-sm-12"></div>
					<div class="col-lg-6 col-sm-12">
						<label for="html">واحد اندازه گیری:</label>
						<select style="width: 100%" v-model="unit" class="search-input">
							<option
								v-for="measurment in wareMeasurment"
								:value="measurment.id"
								:key="measurment.id"
							>
								<span>{{ measurment.unit_fa }}</span>
							</option>
						</select>
					</div>
					<div class="col-lg-6 col-sm-12">
						<label for="html">نوع کالا:</label>
						<select style="width: 100%" v-model="productType" class="search-input">
							<option v-for="types in wareType" :value="types.id" :key="types.id">
								<span>{{ types.verbose_name }}</span>
							</option>
						</select>
					</div>
					<div class="col-lg-12 col-sm-12">
						<b-form-textarea
							id="textarea"
							v-model="textareaProduct"
							placeholder="توضیحات"
							rows="3"
							max-rows="6"
						></b-form-textarea>
					</div>
					<div class="d-flex col-lg-6 col-sm-12 mt-3">
						<input class="ml-2" v-model="checkBox" type="checkbox" />
						<span>این کالا مصرفی می باشد.</span>
					</div>
					<div class="col-lg-12 col-sm-12 mt-3" v-if="checkBox">
						<span>لطفا نوع ویزیت های خود را انتخاب کنید.</span>
						<b-form-group>
							<b-form-checkbox-group v-model="selected">
								<b-form-checkbox v-for="visit in visitTypeList" :key="visit.id" :value="visit.id">{{
									visit.verbose_name
								}}</b-form-checkbox>
							</b-form-checkbox-group>
						</b-form-group>
					</div>
				</div>
			</div>
			<div class="button-container">
				<button @click="openModal" :disabled="checkEmpty" class="continue">ثبت</button>
			</div>
			<b-modal size="lg" v-model="modal" hide-footer centered>
				<div class="my-4">
					<div>لطفا انبار مد نظر جهت ذخیره این کالا را انتخاب کرده و مقدار ورودی را وارد کنید:</div>
					<div class="d-flex justify-content-between align-items-center my-3">
						<div class="w-100">
							<label>مقدار: </label>
							<input v-model="useInputValue" class="inputs w-75" />
						</div>
						<div class="d-flex justify-content-end align-items-end w-100">
							<label for="html">انبار:</label>
							<select v-model="pickLocation" class="inputs w-75">
								<option v-for="location in locationLists" :value="location.id" :key="location.id">
									{{ location.name_fa }}
								</option>
							</select>
						</div>
					</div>
					<!-- <b-form-textarea
						id="textarea"
						v-model="textareaTransaction"
						placeholder="توضیحات"
						rows="3"
						max-rows="6"
						class="mb-3"
					></b-form-textarea> -->
					<div class="d-flex justify-content-end">
						<button @click="postData" :disabled="checkModalEmpty" class="confirm-item">ثبت</button>
					</div>
				</div>
			</b-modal>
		</div>
	</div>
</template>
<script>
// import Tableview from '../../components/Tableview/index.vue';
import Materialnput from '../../components/MaterialInput/indx.vue';

export default {
	components: {
		Materialnput,
	},
	data() {
		return {
			enName: null,
			faName: null,
			productCode: null,
			textareaProduct: null,
			// textareaTransaction: null,
			checkBox: false,
			wareType: [],
			productType: null,
			unit: null,
			visitTypeList: [],
			selected: [],
			wareMeasurment: [],
			modal: false,
			pickLocation: '',
			locationLists: [],
			useInputValue: null,
			wareId: null,
		};
	},
	mounted() {
		this.getWareType();
		this.getVisitType();
		this.getWareMeasurement();
	},
	computed: {
		checkEmpty() {
			if (
				this.enName === null ||
				this.enName === '' ||
				this.faName === null ||
				this.faName === '' ||
				this.productCode === null ||
				this.productCode === '' ||
				this.productType === null ||
				this.textarea === '' ||
				this.textarea === null
			) {
				return true;
			} else {
				if (this.checkBox === true) {
					if (this.selected.length === 0) {
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			}
		},
		checkModalEmpty() {
			if (
				this.useInputValue === null ||
				this.useInputValue === '' ||
				this.pickLocation === null ||
				this.pickLocation === '' 
			) {
				return true;
			} else {
				return false;
			}
		},
	},
	methods: {
		async getWareType() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.WAREHOUSE_TYPE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.wareType = res.data;
			}
		},
		async getWareMeasurement() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.UNIT_LIST_CREATE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.wareMeasurment = res.data;
			}
		},
		async postData() {
			console.log('se:', this.selected);
			const data = {
				name_en: this.enName,
				name_fa: this.faName,
				is_for_use: this.checkBox,
				description: this.textareaProduct,
				type: this.productType,
				identifier: this.productCode,
				unit: this.unit,
				project: this.$STORE.state.userConfig.setProjectId,
			};
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.MULTI.WAREHOUSE_LIST_CREATE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
				data,
			);
			if (res.status === 201) {
				this.wareId = res.data.id;
				const data = {
					lines: [
						{
							ware: this.wareId,
							amount: parseInt(this.useInputValue * -1),
							location: null,
							user: null,
							side: 'FROM',
							involved: null,
						},
						{
							ware: this.wareId,
							amount: parseInt(this.useInputValue),
							location: this.pickLocation,
							user: null,
							side: 'TO',
							involved: 'LOCATION',
						},
					],
					description: `ایجاد ${this.useInputValue} عدد در انبار`,
				};
				const res1 = await this.$ApiServiceLayer.post(
					this.$PATH.RELATIVE_PATH.POST.WARE_TRANSACTION +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
					this.$PATH.SERVICE_NAME.EMPTY,
					data,
				);
				if (res1.status === 200) {
					if (this.checkBox === true) {
						let lists = [];
						if (this.selected.length > 0) {
							for (let i of this.selected) {
								lists.push({
									ware: this.wareId,
									visit_type: i,
								});
							}
						}
						const res2 = await this.$ApiServiceLayer.post(
							this.$PATH.RELATIVE_PATH.MULTI.WARE_VISIT_TYPE +
								'?p=' +
								this.$STORE.state.userConfig.setProjectId,
							this.$PATH.SERVICE_NAME.EMPTY,
							lists,
						);
						if (res2.status === 201) {
							this.$router.push({ name: 'listWareHouse' });
						}
					} else {
						this.$router.push({ name: 'listWareHouse' });
					}
				}
			}
		},
		async getVisitType() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.VISIT_TYPE + '?p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.visitTypeList = res.data;
			}
		},
		async getLocationLists() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.LOCATION_LIST_CREATE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.locationLists = res.data;
			}
		},
		openModal() {
			this.modal = !this.modal;
			this.getLocationLists();
		},
	},
};
</script>
<style lang="scss" scoped>
.create-warehouse {
	padding: 32px 50px;
	.box {
		padding: 24px;
		border-radius: 8px;
		margin-bottom: 16px;
		background: #fff;
		border-radius: 8px;
		box-shadow: none;
		.search-input {
			text-indent: 10px;
			height: 40px;
			border: 1px solid #c4c4c4;
			padding: 0 9px;
			border-radius: 8px;
			font-family: 'IRANYekanfa' !important;
			border-radius: 8px;
			margin: 8px 0;
		}
	}
	.button-container {
		display: flex;
		justify-content: flex-end;
		margin-top: 12px;
		.continue {
			border: none;
			background: #2d8b8b;

			border-radius: 8px;
			color: #fff;
			margin-left: 8px;
			padding: 8px 16px;
			width: 10%;
			&:disabled {
				background: #f1f1f1;
				color: #535656;
				border-radius: 8px;
				border: none;
				padding: 8px;
			}
		}
	}
}
.inputs {
	margin-top: 16px;
	width: 25%;
	height: 38px;
	border: 1px solid #c4c4c4;
	padding: 0 9px;
	border-radius: 8px;
	margin-right: 4px;
}
.confirm-item {
	background: none;
	padding: 8px;
	border: 1px solid #2d8b8b;
	border-radius: 8px;
	background: #2d8b8b;
	color: #fff;
	margin-left: 8px;
	min-width: 75px;
	&:disabled {
		border: none;
		background: #c4c4c4;
	}
}
</style>
